"use client";

import Slider from "react-slick";

import PostCard from "../PostCard";
const styles = new Proxy({"BlogSection":"BlogSection-addec"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });
/*import "./Slider.scss";*/

import play from "./play.svg";
import Section from "@/themes/graboxy/components/Section";
import Link from "next/link";
import { FormattedPost } from "@/lib/blog";

const SETTINGS = {
  dots: true,
  arrows: false,
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: true,
  swipeToSlide: true,
  speed: 200,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

const Blog = ({ posts }: { posts: FormattedPost[] }) => {
  const renderedPosts = posts.map((post) => (
    <PostCard key={post.id} post={post} className="px-3" />
  ));

  return (
    <Section id="Blog" title="Our Blog" className={styles.BlogSection}>
      <div className="Slider">
        <div className="container">
          <div className="row">
            <Slider {...SETTINGS} className="h-100">
              {renderedPosts}
            </Slider>
          </div>

          <div className="row text-center mt-3">
            <div className="col-12">
              <Link href="/blog" className="btn" target="_blank">
                More Blog Articles{" "}
                <img src={play.src} width={20} height={20} alt="Play icon" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default Blog;
